<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <div *ngIf="!downloadnow">
      <h5>Export Questions for {{exam.examinationName}}</h5>
      <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="exportQuestion()">

        <div class="mb-3 mr-0 col-md-10">
          <label class="form-label">Question Format</label>
          <ng-select class="form-select" [(ngModel)]="format" [ngModelOptions]="{ standalone: true }">
            <ng-option selected value="" disabled>Select Format</ng-option>
            <ng-option value="Format1">Format1</ng-option>
            <ng-option value="Format2">Format2</ng-option>
          </ng-select>
        </div>
        <div class="mb-3 mr-0 col-md-10">
          <label class="form-label">Category</label>
          <ng-select [items]="categoryList" [(ngModel)]="category" name="category" bindLabel="category"
            bindValue="category" [searchable]="true" placeholder="Select Category">
          </ng-select>
        </div>

        <button class="btn btn-primary btn-lg col-md-10" type="submit"> Export
        </button>
      </form>
    </div>
    <app-file-download *ngIf="downloadnow" [exportedFile]="exportedFile"></app-file-download>
  </div>
</div>